export default __webpack_public_path__ + "images/3bc134ab46073ceeec532d583648e66f.svg";